import { request } from "@umijs/max";

export async function login(options?: API.LoginParams) {
  return request<API.LoginResponse>('/api/auth/login', {
    method: 'POST',
    data: {
      ...(options || {}),
    },
  });
}
export async function getUserInfo(options?: API.LoginParams) {
  return request<API.UserInfoResponse>('/api/auth/userInfo', {
    method: 'GET',
    ...(options || {}),
  });
}

export async function logout(options?: API.LoginParams) {
  return request<API.LoginResponse>('/auth/logout', {
    method: 'GET',
    ...(options || {}),
  });
}